module.exports = __webpack_public_path__ + "static/media/pr_02_B.4bf242fb.png";